module.exports = __webpack_public_path__ + "img/UserList.684ebbb9.svg";